module.exports = __webpack_public_path__ + "static/media/profile.edf74ca8.svg";